/**
 * Die Leiste nach einer Unterbrechung der Live-Verbindung (Lueckenausgleich, Spec
 * `docs/superpowers/specs/2026-10-24-sse-lueckenausgleich-design.md`, "Store und Anzeige") - NEUBAU ohne
 * Bestandsvorbild. Sie steht in der App-Huelle VOR `<main>` (`App.tsx`), solange `zustand.verbindungsluecke` gesetzt
 * ist: der Strom konnte verpasste Ereignisse nicht nachliefern, die Anzeige kann veraltet sein. Gezeichnet wird sie in
 * einem festen Stapel unter der Kopfzeile, zusammen mit den Konfliktbannern, die sie sonst verdeckte (`App.tsx`, Behaelter
 * `.verbindungsluecke-stapel`; `styles/neubau/verbindungsluecke.css`, Begruendung dort).
 *
 * Eine eigene Flaeche, kein Eintrag im Fehlerstapel (Stapeleintraege haben keine Knoepfe, Regel L5). Eine
 * gescheiterte Ursache steht hier und NICHT zusaetzlich im Stapel (L1 "Kein Doppel"); der Speicher meldet sie dafuer
 * nicht. `ursache` kommt nie fuer Abbruch oder 401 an (dann bleibt sie `null`); ergaebe `fehlertext` trotzdem `null`,
 * entfaellt die Zeile, statt "null" zu zeigen.
 *
 * "Neu laden" ist gesperrt, solange `ladend` gilt: ein Klick waehrend eines Teillaufs (Filterwechsel im Board) bricht
 * diesen ab und laedt den alten bestaetigten Filter - die Liste passte dann nicht zur Filterwahl. Den Fehlertext rechnet
 * ein Memo an `ursache`, denn `fehlertext` meldet einen Programmfehler mit `console.error` (nicht bei jedem Neuzeichnen).
 */
import { useMemo, type JSX } from "react";
import { fehlertext } from "../../lib/fehlertext.ts";

export const VERBINDUNGSLUECKE_SATZ =
  "Die Live-Verbindung war unterbrochen. Änderungen von anderer Seite fehlen womöglich in der Anzeige.";

export interface VerbindungsLueckeProps {
  /** Die Ursache des gescheiterten "Neu laden"; `null`, solange keiner scheiterte. */
  ursache: unknown | null;
  /** `zustand.ladend`: ein Lauf ist unterwegs, "Neu laden" gesperrt. */
  ladend: boolean;
  onNeuLaden: () => void;
  onSchliessen: () => void;
}

export function VerbindungsLuecke({ ursache, ladend, onNeuLaden, onSchliessen }: VerbindungsLueckeProps): JSX.Element {
  const grund = useMemo(() => (ursache === null ? null : fehlertext(ursache)), [ursache]);
  return (
    <div className="verbindungsluecke" role="status">
      <div className="verbindungsluecke-text">
        <p>{VERBINDUNGSLUECKE_SATZ}</p>
        {grund !== null ? <p>{`Das Neuladen ist gescheitert: ${grund}`}</p> : null}
      </div>
      <button type="button" className="btn-sec" disabled={ladend} onClick={onNeuLaden}>
        Neu laden
      </button>
      <button type="button" className="btn-ghost" aria-label="Hinweis schließen" onClick={onSchliessen}>
        ×
      </button>
    </div>
  );
}
